import { cs } from "@common/react/chain-services";
import { consumeContext } from "@common/react/context";
import { Form2 } from "@common/react/cs-form/form2";
import { required } from "@common/react/cs-form/validators/required";
import { SubcribeKeyEvents } from "@common/react/keys/global-key-down";
import { UseState } from "@common/react/use-state";
import { VerbDialogBodyScrollbar } from "@common/ui-components/verb-scrollbar/verb-dialog-body-scrollbar";
import * as React from "react";
import { Button } from "../../../../../../common/form/buttons/button/button";
import { ffToTextInput } from "../../../../../../common/form/ff-to-text-input";
import { TextInput } from "../../../../../../common/form/text-input/text-input";
import { DialogService } from "../../../common/dialog/dialog-service";

export const RenameModelDialog = ({onDone, next: rootNext}) =>
    cs(
        [
            "modal",
            (_, next) =>
                DialogService({
                    render: ({resolve, args: {model}}) => ({
                        title: "Rename Model",
                        width: 540,
                        content: next({
                            resolve,
                            model,
                        }),
                    }),
                    next: rootNext,
                }),
        ],
        consumeContext("apis"),
        [
            "editing",
            ({modal}, next) =>
                UseState({
                    initValue: {
                        name: modal.model.name,
                    },
                    next,
                }),
        ],
        [
            "form",
            ({modal, editing, apis}, next) =>
                Form2({
                    data: editing,
                    fields: {
                        name: {
                            transforms: ["trim"],
                            validators: [required],
                            asyncValidators: [
                                {
                                    validate: (name) => apis.model.checkModelName(name, {}),
                                    getMessage: () => `Existed`,
                                },
                            ],
                            debounce: true,
                        },
                    },
                    onSubmit: async () => {
                        await apis.model.upsertModel({
                            ...modal.model,
                            name: editing.value.name,
                        });
                        onDone?.({});
                        modal.resolve();
                    },
                    next,
                }),
        ],
        ({modal, form}) => (
            <div className="rename-collection-dialog-zd9">
                <VerbDialogBodyScrollbar>
                    <div className="main-part">
                        {TextInput({
                            label: "Rename Model",
                            ...ffToTextInput(form.field("name")),
                        })}
                    </div>
                </VerbDialogBodyScrollbar>
                {SubcribeKeyEvents({
                    events: [
                        {
                            keyCombo: "Enter",
                            onKeyDown: () => form.looksValid && form.submit(),
                        },
                    ]
                })}
                <div className="buttons">
                    <Button btnType="secondary" onClick={() => modal.resolve()}>
                        Cancel
                    </Button>
                    <Button disabled={!form.looksValid} onClick={form.submit}>
                        Rename
                    </Button>
                </div>
            </div>
        )
    );
